import {Accordion, AccordionDetails, AccordionSummary, Dialog, Grid, Stack, Typography} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {useIsMobileHook, weaponImageName} from "../utils";
import {Link, useNavigate, useParams} from "react-router-dom";
import {allWeapons} from "../builder/WeaponData";
import LoadoutDisplay from "../builder/share/LoadoutDisplay";

export const ranking = [
    {
        name: "S",
        color: "#FF7F7F",
        weapons: ["ACR", "MP7"]
    },
    {
        name: "A",
        color: "#FFBF7F",
        weapons: ["M4A1", "AK-47", "MP5A2", "Vector .45", "M60", "TAC-50", "P90"]
    },
    {
        name: "B",
        color: "#FFDF7F",
        weapons: ["RPK-74", "Double-Barreled", "MK 20 SSR", "M44", "M16A4"]
    },
    {
        name: "C",
        color: "#FFFF7F",
        weapons: ["MDR", "M249", "M870", "SVD"]
    },
    {
        name: "F",
        color: "#BFFF7F",
        weapons: ["AA-12"]
    }
]

function weaponImage(weapon) {
    return <div
        style={{
            backgroundImage: `url(${require('../assets/weapons/outline/' + weaponImageName(weapon) + '.png')})`,
            height: '50px',
            width: '95%',
            margin: '5px',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'contain'
        }}
        aria-description={weapon}
    />;
}

function weaponName(weapon) {
    return weapon.name === "Double-Barreled" ? "Double-B." : weapon.name
}

const MetaWeaponItem = ({weapon}) => {
    return (

        <Grid item xs='auto'>
            <Link to={`/meta/${weaponImageName(weapon)}`} style={{textDecoration: 'none'}}>
                <Stack alignItems='center' sx={{
                    m: '10px',
                    p: '4px',
                    width: '160px',
                    borderRadius: '4px',
                    backgroundColor: 'rgb(0,0,0,0.1)',
                    boxShadow: '0 0 5px 0 rgb(0,0,0,0.5)',
                    transition: 'all 0.3s ease',
                    '&:hover': {backgroundColor: 'rgba(80,80,80,0.1)', boxShadow: '0 0 5px 1px rgba(255,255,255,0.3)'}
                }}>
                    {weaponImage(weapon)}
                    <Typography variant='h6' fontWeight='normal' fontStyle='normal'
                                color='text.primary'>{weaponName(weapon)}</Typography>
                </Stack>
            </Link>
        </Grid>
    )
}

function createWeapons(tier) {
    return tier.weapons.map((weapon) => <MetaWeaponItem weapon={{name: weapon}}/>)
}

const MetaTierAccordion = ({tier}) => {
    return (
        <Accordion elevation={10} defaultExpanded={true} disableGutters sx={{borderRadius: '5px',  backgroundColor: '#24262b', boxShadow: '0px 0px 6px 1px #00000065', m: {xs: '5px 0', md: '8px 0'}}}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon sx={{color: tier.color}}/>}
                aria-controls="advanced-content"
                id="advanced-header"
            >
                <Typography fontSize='1.8rem' fontWeight='bold' color={tier.color}
                            sx={{textShadow: '1px 1px 1px #000000'}}>
                    {`${tier.name} Tier`}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container justifyContent={{xs: 'center', md: 'start'}}>
                    {createWeapons(tier)}
                </Grid>
            </AccordionDetails>
        </Accordion>
    )
}

const createTiers = () => {
    return ranking.map((tier) => <MetaTierAccordion tier={tier}/>)
}

const MetaWeaponDialog = ({weapon}) => {
    const navigate = useNavigate()

    return <Dialog sx={{minWidth: {xs: '90%', md: '800px'}}} maxWidth={false} open={weapon != null}
                   onClose={() => navigate('/meta')}>
        {
            weapon == null ? null :
                <LoadoutDisplay weapon={weapon} type='featured'/>
        }
    </Dialog>;
}

function MetaPage() {
    const isMobile = useIsMobileHook()
    const weaponName = useParams().metaWeapon
    const weapon = allWeapons.find(w => weaponImageName(w) === weaponName)
    return (
        <Stack>
            <Stack sx={{width: {xs: '100%', md: '70%'}, alignSelf: 'center'}}>
            <Typography sx={{textAlign: 'center', color: 'white', fontSize: '1.6rem', lineHeight: '1.25', fontWeight: 'normal', fontStyle: 'oblique', margin: '0 0 8px' }}>XDLoadout Meta Tierlist</Typography>
            <h1 style={{textAlign: 'center', color: 'white', fontSize: isMobile ? '0.875rem' : '1rem', lineHeight: '1.25', fontWeight: 'normal', fontStyle: 'oblique', margin: '0 0 20px'}}>
                In this tierlist you'll find the best XDefiant weapon classes and attachment builds from the top competitive players and best content creators. See the absolute meta ACR and MP7 attachments, and classes for all other weapons.
            </h1>
            </Stack>
            <Stack sx={{width: {xs:'100%', md:'85%'}, alignSelf: 'center'}}>
                {createTiers()}
            </Stack>
            <MetaWeaponDialog weapon={weapon}/>
        </Stack>
    )
}

export default MetaPage